/**
 * Resolver arguments for memoizing all arguments passed in lodash/memoize
 * @return {string}
 */

export const keyResolver = (...args: string[]) => JSON.stringify(args);

export default keyResolver;
